import React from 'react';
import classnames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';

import DirectionButton from 'components/atoms/DirectionButton';

import Coupon, { ColorStyle } from 'components/molecules/Coupon';

import { CouponEventResource } from 'util/api/swaggerApi/data-contracts';

import 'swiper/css';
import 'swiper/css/navigation';
import styles from './index.module.css';

interface CouponCardType extends CouponEventResource {
	colorStyle: ColorStyle;
}

interface CouponCarouselProperty {
	data: CouponCardType[];
	className?: string;
	clickCoupon?: () => void;
}

const CouponCarousel: React.FC<CouponCarouselProperty> = ({
	className = '',
	data,
	clickCoupon = () => {},
}) => (
	<div className={classnames(styles.wrapper, className)}>
		<DirectionButton
			direction="left"
			appear="border"
			handleClick={() => {}}
			className={classnames('coupon-swiper-prev', styles.direction, styles.left)}
		/>
		<Swiper
			spaceBetween={5}
			slidesPerView={3}
			slidesPerGroup={3}
			navigation={{
				prevEl: '.coupon-swiper-prev',
				nextEl: '.coupon-swiper-next',
				disabledClass: styles.disabled,
			}}
			modules={[Navigation]}
			className={classnames(styles.swiper, className)}
		>
			<div className={styles.container}>
				{data.map(
					({
						title = '',
						name = '',
						subTitle = '',
						colorStyle = 'purple',
						hashtag = '',
						briefDescription = '',
					}) => (
						<SwiperSlide className={styles.swiperSlide} key={name}>
							<Coupon
								subtitle={subTitle}
								title={title}
								hashtag={hashtag}
								colorStyle={colorStyle}
								briefDescription={briefDescription}
								className={styles.coupon}
								onClick={clickCoupon}
							/>
						</SwiperSlide>
					),
				)}
			</div>
		</Swiper>
		<DirectionButton
			direction="right"
			appear="border"
			handleClick={() => {}}
			className={classnames('coupon-swiper-next', styles.direction, styles.right)}
		/>
	</div>
);

export default CouponCarousel;
